export class SignInState {
  readonly message: string;
  constructor(param: SignInState) {
    this.message = param.message;
  }
}
